//archivo ApiKey.js
export default { 
	USER_ID: 'z0_91vyP6e0Sbwce3', 
	TEMPLATE_ID: 'template_mineris_web',
	SERVICE_ID: 'service_dpevz75'
}